<template>
    <div>
        
        <p :class="'font-weight-bold text-center headline pa-2 customGrey--text'">{{globalLanguage.feedbackTitle}}</p>
        
        <v-container v-if="othersFeedbacks != []" class="pt-2">
            <v-row no-gutters>
                <v-col class="text-center"  xs="4" sm="1">
                </v-col>
                <v-col class="text-center"  xs="4" sm="10">
                    <v-layout  align-center justify-center column>
                        <v-card elevation="5">
                        <v-carousel 
                            ref="feedbackCarousel"
                            height="auto"
                            cycle
                            show-arrows-on-hover
                            hide-delimiters
                            progress
                            :progress-color="globalColorB"
                            interval="8000"
                            >
                            <v-carousel-item
                                v-for="(feedback , index) in othersFeedbacks"
                                :key="index"
                            >
                                    <v-container class="pt-3" >
                                        <v-row no-gutters>
                                            <v-col class="text-right pt-3"  cols="auto"  xs="4" sm="2">
                                                <v-layout align-center justify-center column>
                                                    <v-img
                                                        :src="feedback.data.image"
                                                        max-width="150"
                                                    ></v-img>
                                                </v-layout>
                                            </v-col>
                                            <v-col class="text-left" cols="auto"  xs="8" sm="10">
                                                <v-rating
                                                    :color="globalColorB"
                                                    :background-color="globalColorB"
                                                    empty-icon="mdi-star-outline"
                                                    full-icon="mdi-star"
                                                    half-icon="mdi-star-half-full"
                                                    hover
                                                    length="5"
                                                    :value="feedback.data.rating"
                                                    readonly
                                                ></v-rating>
                                                <span :class="'font-weight-medium subtitle-1 customGrey--text'">{{feedback.data.name}}</span><br/>
                                                <span :class="'font-weight-medium subtitle-1 customGrey--text'">{{feedback.data.email}}</span><br/>
                                                <span :class="'font-weight-light subtitle-2 customGrey--text'">{{feedback.data.date}}</span><br/>
                                                <p :class="'font-weight-light subtitle-2 customGrey--text'">{{feedback.data.comment}}</p>
                                            </v-col>
                                        </v-row> 
                                    </v-container>
                                </v-carousel-item>
                            </v-carousel> 
                        </v-card>
                    </v-layout>
                </v-col>
                <v-col class="text-center"  xs="4" sm="1">
                </v-col>
            </v-row>
        </v-container>

        <p v-if="othersFeedbacks.length != 0" :class="'font-weight-medium text-center headline pt-5 customGrey--text'">{{globalLanguage.landingSolutionOr}}</p>
        <p v-if="othersFeedbacks.length != 0" :class="'font-weight-light text-center title pt-5 customGrey--text'">{{globalLanguage.feedbackInstruction}}</p>
        <p v-if="othersFeedbacks.length == 0" :class="'font-weight-light text-center title pt-5 customGrey--text'">{{globalLanguage.feedbackInstruction2}}</p>

        
        <!-- <v-btn @click="testGoogle()">TEST Google</v-btn> -->
        <v-btn :color="globalColorC" x-large width="250" @click="GoogleSignIn()">
            <v-icon :color="globalColorB" >mdi-comment-quote</v-icon>
            <span :class="'font-weight-bold text-center title pa-2 salmonOrange--text'">Feedback</span>
        </v-btn>
        <!-- <v-btn @click="testAdd()">TEST</v-btn>
        <v-btn @click="testGoogleOut()">TEST Google out</v-btn> -->
        <p :class="'font-weight-light text-center subtitle-1 pt-5 customGrey--text'">{{globalLanguage.feedbackClaim}}</p>

        <v-dialog
            class="z-index:100"
            v-model="feedbackDialog"
            persistent
            transition="dialog-bottom-transition"
            width="800"
        >
        <v-card >
            <v-toolbar
            dark
            :color="globalColorC"
            >
            <v-btn
                icon
                dark
                @click="feedbackDialog = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title :class="'font-weight-medium title pa-3 salmonOrange--text'">Feedback</v-toolbar-title>
            </v-toolbar>
            <v-list
                three-line
                subheader
            >
            <v-form v-model="feedbackValidate">
                <v-list-item>
                    <v-list-item-content class="pa-2">
                        <div>
                            <v-img
                                :src="feedbackImage"
                                max-width="90"          
                            ></v-img>
                        </div>
                        <span :class="'font-weight-medium subtitle-1 customGrey--text'">{{feedbackName}}</span><br/>
                        <span :class="'font-weight-medium subtitle-1 customGrey--text'">{{feedbackEmail}}</span><br/>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content class="pa-2">
                        <v-list-item-title>{{globalLanguage.feedbackComment}} : </v-list-item-title>
                        <v-textarea
                            :full-width="true"
                            clearable
                            :placeholder="globalLanguage.feedbackComment"
                            outlined
                            :value="feedbackComment"
                            v-model="feedbackComment"
                            dense
                            :color="globalColorB"
                        ></v-textarea><br/>
                        <span :class="'font-weight-light subtitle-2 customGrey--text'">Give your comment either in English or Bahasa Melayu</span><br/>
                        <span :class="'font-weight-light subtitle-2 customGrey--text'">Tinggalkan komen anda dalam Bahasa Melayu atau English</span><br/>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content class="pa-2">
                        <v-list-item-title>{{globalLanguage.feedbackRating}} : </v-list-item-title>
                        <v-rating
                            class="text-left "
                            :color="globalColorB"
                            :background-color="globalColorB"
                            empty-icon="mdi-star-outline"
                            full-icon="mdi-star"
                            half-icon="mdi-star-half-full"
                            hover
                            length="5"
                            :value="feedbackRating"
                            v-model="feedbackRating"
                        ></v-rating>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content class="pa-2">
                        <v-btn :color="globalColorC" x-large width="250" @click="submitFeedback()">
                        <v-icon >mdi-send</v-icon>
                        <span :class="'font-weight-bold text-center title pa-1 salmonOrange--text'">{{globalLanguage.feedbackSubmit}}</span>
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>
            </v-form>

            </v-list>
        </v-card>
        </v-dialog>

        <v-snackbar
          v-model="feedbackSuccess"
          centered
          timeout="3500"
        >
          <p :class="`font-weight-light headline white--text`">{{globalLanguage.feedbackThanks}}</p>
          
      </v-snackbar>

      <!-- <v-btn @click="getCarouselHeight()">TEST</v-btn> -->
    </div>

    
</template>

<script>
import Landing from '../Landing.vue'
export default {
  components: { Landing },
    
  name: 'Feedback',
  props: ['globalColorA','globalColorB',"globalColorC","globalLanguage"],
  data(){
    return {
        othersFeedbacks : [],
        feedbackDialog : false,
        feedbackName : "",
        feedbackEmail : "",
        feedbackRating : 3,
        feedbackDate : "",
        feedbackImage : "",
        feedbackComment : "",
        feedbackValidate : true,
        feedbackSuccess : false,
    }
  },

  mounted(){
      this.getFeedbacks()
  },

  methods:
  {
    getCarouselHeight () {
        // var item = document.getElementsByClassName('v-image__image--cover')
        // this.carouselHeight = item[1].clientHeight
        
        // // console.log(this.$refs.feedbackCarousel.items)
        // // console.log(this.$refs.feedbackCarousel.items[0].$el.clientHeight)
        // for(var i = 0 ; i < this.$refs.feedbackCarousel.items.length ; i++)
        // {
        //     var temp = this.$refs.feedbackCarousel.items[i]
        //     console.log(temp)
        // }
        // console.log(this.$refs.feedbackCarousel.$el.clientHeight)
    },
    getFeedbacks()
    {
        this.othersFeedbacks = []
        // get db data
        const db = this.$firebase.firestore();
        db
            .collection('users_feedback')
            .get()
            .then(snap => {
                const getFeedbacks = [];
                snap.forEach(doc => {
                    getFeedbacks.push({ "data": doc.data() });
                });
                this.othersFeedbacks = getFeedbacks
        });
    },

    submitFeedback()
    {
        //submit
        var newDate = new Date();

        var fullDate = newDate.getDate() + " / " + (newDate.getMonth() + 1) + " / " + newDate.getFullYear()

        var submitData = {
            name : this.feedbackName,
            email : this.feedbackEmail,
            image : this.feedbackImage,
            comment : this.feedbackComment,
            date : fullDate,
            rating : this.feedbackRating
        }

        var self = this

        // console.log(submitData)

        // get db data
        const db = this.$firebase.firestore();
        db
            .collection('users_feedback')
            .add(submitData)
            .then(() => {
                self.feedbackComment = ""
                self.feedbackRating = 3
                self.feedbackSuccess = true
                self.feedbackDialog = false
                self.GoogleSignOut()
                self.getFeedbacks()

            .catch((err) => {
                console.log("ERROR")
            });
        });
    },

    GoogleSignIn()
    {
        const provider = new this.$firebase.auth.GoogleAuthProvider();

        this.$firebase.auth().signInWithPopup(provider).then((result) => {
            this.feedbackDialog = true
            this.feedbackName = result.additionalUserInfo.profile.name
            this.feedbackEmail = result.additionalUserInfo.profile.email
            this.feedbackImage = result.additionalUserInfo.profile.picture
        }).catch((err) => {
            console.log(err)
        })
    },

    GoogleSignOut()
    {
        this.$firebase.auth().signOut().then(() => {
            // console.log("sign out")
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/subComponent/feedback.vue